var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classroom"},[_c('h2',{staticClass:"title"},[_vm._v("实战课堂")]),_c('classroom-advantage'),_c('classroom-scenario'),_c('v-free-apply')],1)}
var staticRenderFns = []

export { render, staticRenderFns }